export const sidebarData = [
  {
    name: "Dashboard",
    routepath: "/dashboard",
    iconClass: "fas fa-chart-bar",
  },
  {
    name: "Meus Projetos",
    routepath: "/projects",
    iconClass: "fas fa-cubes",
  },
  // Seção Marketplace temporariamente ocultada da sidebar
  // {
  //   name: "Marketplace",
  //   iconClass: "fas fa-store",
  //   tourId: "marketplace",
  //   child: [
  //     {
  //       listname: "Solicitar Serviço",
  //       routepath: "/order-quote",
  //       iconClass: "fas fa-file-contract",
  //     },
  //     {
  //       listname: "Cadastro de Piloto",
  //       routepath: "/pilot-registration",
  //       iconClass: "fas fa-user-tie",
  //     },
  //   ],
  // },
  {
    name: "Planos",
    routepath: "/plans",
    iconClass: "fas fa-gem",
  },
];
